import Tooltip from "@/components/atoms/Tooltip/Tooltip";
import { convertSBCPrice } from "@/functions/convertPlayerPrice";
import { cn } from "@/lib/utils";
import { Solution } from "@/redux/sbcs/sbcsSlice";
import React from "react";

type SolutionCostProps = {
  solution: Solution;
  isMobile?: boolean;
};

const SolutionCost: React.FC<SolutionCostProps> = ({ solution, isMobile }) => {
  const container = cn(
    isMobile
      ? "flex w-screen justify-center bg-[#052132]/60 h-12 mb-4 gap-6"
      : "grid grid-cols-3 items-center justify-items-center gap-4 bg-[#052132]/70 h-10 my-12 mx-auto px-3 rounded-lg w-fit shrink-0",
  );

  const group = cn(
    "flex items-center justify-center",
    isMobile ? "gap-1" : "gap-2",
  );
  const iconBox = "flex items-center justify-center w-7 h-7 shrink-0";
  const text = cn(isMobile ? "text-sm" : "text-base", "font-bold leading-none");

  return (
    <div className={container}>
      <Tooltip content="Total Cost" delayDuration={150}>
        <div className={group}>
          <div className={iconBox}>
            <img
              alt="fc24coin"
              src={`${import.meta.env.VITE_APP_ASSETS_BASE_URL}/fc24/misc/fc24coin.png`}
              className="w-6 h-6 object-contain"
            />
          </div>
          <p className={text}>
            {solution?.players ? convertSBCPrice(solution?.cost) : "-"}
          </p>
        </div>
      </Tooltip>
      <Tooltip content="Owned Players" delayDuration={150}>
        <div className={group}>
          <div className={iconBox}>
            <img
              className="w-7 h-7"
              src={`${import.meta.env.VITE_APP_ASSETS_BASE_URL}/sbc-icons/owned.png`}
              alt="owned"
            />
          </div>
          <p className={text}>
            {solution?.players ? solution?.ownedPlayersCount : "-"}
          </p>
        </div>
      </Tooltip>
      <Tooltip content="Transfer Market Cost" delayDuration={150}>
        <div className={group}>
          <div className={iconBox}>
            <img
              className="w-7 h-7"
              src={`${import.meta.env.VITE_APP_ASSETS_BASE_URL}/sbc-icons/transfer-market.png`}
              alt="transfer market"
            />
          </div>
          <p className={text}>
            {solution?.players
              ? convertSBCPrice(solution?.transferMarketCost)
              : "-"}
          </p>
        </div>
      </Tooltip>
    </div>
  );
};

export default SolutionCost;
